module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0740.38599b22.jpg";